module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item__background"
  }, [_c('div', {
    staticClass: "item__background__image",
    style: ({
      backgroundImage: 'url(' + _vm.project.thumbnail + ')',
      transform: _vm.scale
    })
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6c53a085!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Slider/SliderItemBackground.vue
// module id = 89
// module chunks = 2